
<template>
  <div class="tf-vue-bg-grey-darker">
    <a href="javascript:void(0)" class="text-white text-decoration-none d-flex align-items-center justify-content-center w-100 h-100 p-2" data-bs-toggle="modal" data-bs-target="#familyModal">
      <i class="icon-information"></i>
    </a>
    <div
      id="familyModal"
      class="modal-title modal"
      tabindex="-1"
      aria-labelledby="familyModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content p-4">
          <div class="container">
        <div class="mb-3 row text-dark">
          <div class="col-12">
            <h4 class="text-center">Family Discount</h4>
          </div>
        </div>
        <div class="row text-dark">
          <div class="col-12">
          <p class="fw-bold">It looks as if you’re travelling as a family…</p>
            <p class="fw-bold">
              Please select the family discount if the person you are travelling with is your spouse/partner 
              and there are children to be insured (maximum 6 children up to 18, or 21 if in full-time education), 
              and they are the children of the principally insured person. For families travelling together, 
              adults pay normal premium, the first child pays half premium and all other children are insured free of charge.
            </p>
          </div>
        </div>
      </div>

      <div class="text-center my-5">
          <button type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal">Cancel</button>
        </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  props: ['quoteType'],
  data() {
    return {
      modalTitle: '',
      modalShow:false,
    }
  },
  computed: {
    title() {
      if(this.quoteType === 'SINGLEG') {
        return 'Single Trip Insurance'
      } else {
        return 'Annual Multi-Trip'
      }
    },
  },
  methods: {
    hideModal() {
      this.modalShow = false
    },
  }
}
</script>
<style scoped>
</style>